import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import classNames from 'classnames';
import { FormControlLabel, Radio } from '@material-ui/core';
import _ from 'lodash';

import Icon from 'src/components/Icon/Icon';
import TypeCodes from 'src/components/HorseBetting/FastMode/TypeCodesModal/TypeCodes';
import DraggableDialog from 'src/components/DraggableDialog/DraggableDialog';
import useIsMobile from 'src/hooks/useIsMobile';
import { RootState } from 'src/configs/store';

interface eventInfo {
    code : number,
    events: {
      code: number
      marketCount: number,
      name:string,
      status: string
    }[]
  }

export default function CodeSearch() {
  const { typeOfCode } = useSelector((state: RootState)  => state.peripherals);

  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [openModal, setOpenModal] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const mobile = useIsMobile();

  const cleanError = (e=null) => {
    if (e){
      e.preventDefault();
    }

    setCode('');
    setError('');
  };

  // eslint-disable-next-line no-unused-vars
  const checkIfValidInput = (code) => {
    const codeSearch =  /\b(?=(?:[1-9]*[A-I]){0,4}(?![1-9]*[A-I]))(?=(?:[A-I]*[1-9]){0,4}(?![A-I]*[1-9]))[A-I1-9]+\b/.test(code);
    const checkIfRepeated = _.uniq(code).length !== code.length;
    if (!codeSearch || code.length > 8 || checkIfRepeated){
      setError(t('betCodeSearch.invalidFormat'));
    }
  };

  const changeTypeCode = (code) => {
    dispatch.peripherals.changeTypeOfCode(code);
    cleanError();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const eventInfo:eventInfo = await dispatch.events.searchBetCode({ code, productType:4 });

    if (eventInfo){
      const event = eventInfo?.events[0].code;
      history.push(`/lotto/${ eventInfo?.code }/${ event }`);
    } else {
      setError(t('betCodeSearch.error'));
    }
  };

  const handleChange = (e) => {
    e.preventDefault();

    if (error) {
      setError('');
    }
    // if (e.target.value){
    //   checkIfValidInput(e.target.value.toUpperCase());
    // }
    setCode(e.target.value.toUpperCase());
  };

  const handleRadioChange = (type) => {
    dispatch.lotto.resetLottoRetailValues();
    changeTypeCode(type);
  };

  return (
    <>
      <div className="code-search__radio-container">
        <FormControlLabel
          value="none"
          className="code-search__radio"
          control={
            <Radio
              color="primary"
              checkedIcon={ <Icon icon="radioButton" /> }
              icon={ <Icon icon="radioButtonOpen" /> }
              checked={ typeOfCode === 'cardCode' }
              onChange={ () => handleRadioChange('cardCode') }
              className="code-search__radio"
            />
          }
          label={ <span className="code-search__radio--label">{ t('typeOfCode.cardCode') }</span> }
        />
        <FormControlLabel
          value="none"
          className="code-search__radio"
          control={
            <Radio
              color="primary"
              checkedIcon={ <Icon icon="radioButton" /> }
              icon={ <Icon icon="radioButtonOpen" /> }
              checked={ typeOfCode === 'couponCode' }
              onChange={ () => handleRadioChange('couponCode') }
              className="code-search__radio"
            />
          }
          label={ <span className="code-search__radio--label">{ t('typeOfCode.couponCode') }</span> }
        />
      </div>
      <div className="code-search__title code-search__title--selectable" onClick={ () => setOpenModal(true) }>{ t('betCodeSearch.cardCode') }</div>
      <form onSubmit={ handleSubmit } className="code-search__form">
        <input
          type="text"
          autoComplete="new-password"
          value={ code }
          onChange={ handleChange }
          placeholder={ t(`typeOfCode.${ [typeOfCode] }`) }
          className={
            classNames({
              'code-search__input' : true,
              'code-search__input--error': error
            })
          }
        />
        {
          error && <Icon
            icon="trash"
            className="code-search__error-icon"
            onClick = { cleanError }
          />
        }
        <button
          type="submit"
          className={
            classNames({
              'code-search__button' : true,
              'code-search__button--disabled': error || code === ''
            })
          }
        >
          <Icon
            icon="return"
            className={
              classNames({
                'code-search__check': true,
                'code-search__check--disabled': error || code === ''
              })
            }
          />
        </button>

      </form>
      {
        error &&
        <div className="code-search__error">
          { error }
          {
            error !== t('betCodeSearch.invalidFormat') &&
            <span onClick={ () => setOpenModal(true) } className="code-search__list"> { t('betCodeSearch.cardCode') }</span>
          }
        </div>
      }
      {
        openModal &&
        <DraggableDialog className="event-row__dialog" placement="right-start" disablePortal={ mobile }>
          <DraggableDialog.Content>
            <TypeCodes closeModal={ () => setOpenModal(false) } title={ t('typeCodes.cardCodesLottoTitle') }>
              <TypeCodes.CardCodes productType={ 4 } />
            </TypeCodes>
          </DraggableDialog.Content>
        </DraggableDialog>
      }
    </>
  );
}
